const baseUrl = process.env.REACT_APP_BACKEND_URL ?? ''

/**
 * Call GET API
 * @param url string
 * @returns result
 */
export const get = async (url: string) => {
  const response = await fetch(baseUrl + url, {
    method: 'GET',
  })
  const result = await response.json()

  return result
}

/**
 * Call POST API
 * @param url string
 * @param data Record<string, any>
 * @returns result
 */
export const post = async (url: string, data: Record<string, unknown>) => {
  const response = await fetch(baseUrl + url, {
    method: 'POST',
    body: JSON.stringify(data),
  })
  const result = await response.json()

  return result
}

/**
 *
 * @param url string
 * @param body FormData
 * @returns result
 */
export const postForm = async (url: string, body: FormData) => {
  const response = await fetch(baseUrl + url, {
    method: 'POST',
    body,
  })

  const result = await response.json()

  return result
}

/**
 * Call delete API
 * @param url string
 * @returns result
 */
export const del = async (url: string) => {
  const resposne = await fetch(baseUrl + url, {
    method: 'DELETE',
  })

  const result = await resposne.json()

  return result
}
